const selectors = {
	galleries: '.js--galleries-preview'
};

const slides = ['mod--step-01', 'mod--step-02'];
const time = 10000; // time video
let slideInterval;
let galleriesBox;
let video01;
let video02;
let prevRatio = 0.0;
let isEnergySavingMode = false;
const options = {
	root: null,
	rootMargin: '0px',
	threshold: 0.3
};

const checkEnergySavingMode = video => {
	video.play().then(() => {
		isEnergySavingMode = false;
	}).catch(() => {
		isEnergySavingMode = true;
	});
};

const videoPlay = video => {
	video.play();
};

const videoStop = video => {
	video.pause();

	if (!isEnergySavingMode) {
		video.currentTime = 0;
	}
};

const slidesStart = () => {
	if (galleriesBox.classList.contains(slides[0])) {
		videoPlay(video01);
	} else {
		videoPlay(video02);
	}

	slideInterval = setInterval(function () {
		if (galleriesBox.classList.contains(slides[0])) {
			galleriesBox.classList.remove(slides[0]);
			galleriesBox.classList.add(slides[1]);
			videoPlay(video02);
		} else {
			galleriesBox.classList.remove(slides[1]);
			galleriesBox.classList.add(slides[0]);
			videoPlay(video01);
		}
	}, time);
};

const slidesStop = () => {
	videoStop(video01);
	videoStop(video02);

	clearInterval(slideInterval);
};

const handleIntersect = entries => {
	entries.forEach(entry => {
		if (entry.intersectionRatio > prevRatio) {
			slidesStart();
		} else {
			slidesStop();
		}

		prevRatio = entry.intersectionRatio;
	});
};

const createObserver = () => {
	let observer;

	observer = new IntersectionObserver(handleIntersect, options); // eslint-disable-line
	observer.observe(galleriesBox);
};

const galleriesMain = () => {
	window.addEventListener('load', () => {
		galleriesBox = document.querySelector(selectors.galleries);
		video01 = document.getElementById('video-step-01');
		video02 = document.getElementById('video-step-02');

		checkEnergySavingMode(video01);

		createObserver();
	}, false);
};

const render = () => {
	galleriesMain();
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/galleries-main/galleries-main.js